import styled from 'styled-components';

export const DesiccantMapViewContainer = styled.div<{ $textColor: string }>`
  z-index: 2;
  height: 100%;
  width: 100%;
  padding: ${({ theme: { token } }) => token.paddingXL}px ${({ theme: { token } }) => token.padding}px;
  display: flex;
  flex-direction: column;
  ${({ $textColor }) => $textColor && `padding-top: ${({ theme: { token } }) => token.marginXXL}px;`};

  .header {
    display: flex;
    align-items: flex-end;
    height: ${({ $textColor }) => ($textColor ? '50%' : '33%')};

    .title-wrapper {
      min-width: 76%;
      flex-grow: 1;
    }

    .type {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }
  }

  .in-maintenance-title {
    position: absolute;
    top: 14px;
    left: 30px;
    color: ${({ $textColor }) => $textColor};
  }

  .value {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .label {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }

  .package-care-wrapper {
    position: absolute;
    bottom: 40px;
    left: 5px;
    width: 132px;
  }
`;
